Object.defineProperty(exports, "__esModule", {
  value: true
});
var MIN_HEADING_LEVEL = exports.MIN_HEADING_LEVEL = 1;
var MAX_HEADING_LEVEL = exports.MAX_HEADING_LEVEL = 6;

var headingTags = exports.headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/headingLevels.js
// module id = 155
// module chunks = 168707334958949